export default "__VITE_ASSET__FgvphbSO__"